module.exports = __webpack_public_path__ + "static/tree-r-mobile-cd008fe1ec3c5c9213e44dee18f2ccf9.png";